import React from "react";
import { inject, observer } from "mobx-react";
import { DataType } from "src/types";
import { RootStore } from "src/stores";
import { EditDeliverable } from "./editDeliverable";
import { EditMeeting } from "./editMeeting";
import { EditMilestone } from "./editMilestone";
import { EditQuestion } from "./editQuestion";

export interface IEditItemProps {
  rootStore?: RootStore;
}

export const EditItem = inject("rootStore")(
  observer((props: IEditItemProps) => {
    const { rootStore } = props;
    if (!rootStore.getActiveItem) return null;
    switch (rootStore.getActiveItem.data_type) {
      case DataType.Question:
        return <EditQuestion />;
      case DataType.Deliverable:
        return <EditDeliverable />;
      case DataType.Milestone:
        return <EditMilestone />;
      case DataType.Meeting:
        return <EditMeeting />;
      default:
        console.error("DataType not supported by EditItem");
        return <></>;
    }
  })
);
